module.exports = __webpack_public_path__ + "static/media/cardCoin.b21ace03.png";